
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M1.929 12L9 4.929 16.071 12\" stroke=\"currentColor\" stroke-width=\"1.5\" fill=\"none\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
